import React, { memo } from 'react'
import { Icon, IconName } from '@unbounded/unbounded-components'
import { SocialUrl, SocialUrlType } from '~api'
import { splitSocialUrls } from './SocialLinks.utils'
import * as Styled from './SocialLinks.styles'

interface Props {
  socialUrls: SocialUrl[]
}

const getSocialItemContent = ({ type, url }: SocialUrl) => {
  if (type === SocialUrlType.Website) {
    return new URL(url).hostname
  }

  return <Icon name={IconName[`brand_squared_${type}`]} size="large" />
}

const SocialLinks: React.FC<Props> = memo(({ socialUrls }) => {
  const { website, socialItems } = splitSocialUrls(socialUrls)

  const renderSocialItem = (socialUrl: SocialUrl) => (
    <Styled.SocialButton key={socialUrl.type} href={socialUrl.url} target="_blank" rel="noopener noreferrer">
      {getSocialItemContent(socialUrl)}
    </Styled.SocialButton>
  )

  return (
    <Styled.Container>
      {website && (
        <Styled.WebsiteLink href={website.url} target="_blank" rel="noopener noreferrer">
          {getSocialItemContent(website)}
        </Styled.WebsiteLink>
      )}

      <Styled.SocialList>{socialItems.map(renderSocialItem)}</Styled.SocialList>
    </Styled.Container>
  )
})

SocialLinks.displayName = 'SocialLinks'
export default SocialLinks
